import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

export function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export function useUpdateQuery() {
  const router = useHistory();

  const updateQueryParams = (params: {
    callback: (searchParams: URLSearchParams) => void;
    pathname?: string;
    replace?: boolean;
  }) => {
    const { callback, pathname, replace = false } = params;
    const searchParams = new URLSearchParams(window.location.search);

    callback(searchParams);

    const newUrl = `${pathname || window.location.pathname}${
      searchParams.toString() ? `?${searchParams.toString()}` : ''
    }`;

    router[replace ? 'replace' : 'push'](newUrl);
  };

  return updateQueryParams;
}
